import React from 'react';

export default props => {
    return (    
        <svg width="25px" height="33px" viewBox="0 0 25 33" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="search" transform="translate(-578.000000, -10.000000)" stroke="#2472b9" strokeWidth="2">
                    <g id="Group-7-Copy-3" transform="translate(588.160254, 27.722432) rotate(-330.000000) translate(-588.160254, -27.722432) translate(578.160254, 10.722432)">
                        <circle id="Oval-5" fillOpacity="0.1" fill="#2472b9" cx="9.71428571" cy="9.71428571" r="9.71428571"></circle>
                        <path d="M9.60714286,24 L9.60714286,33.7142857" id="Line-4" strokeLinecap="round"></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}



// WEBPACK FOOTER //
// ./src/images/SearchIcon.js